import React from 'react'
import { renderModifiedGroup, renderRegularGroup } from '../AllOrgActivities/formHelper';
import { getDriverRatesZonesColumns, groupDifferencesByAction } from '../AllOrgActivities/helper';
import { Card, Col, Row } from 'antd';

export const CityZipCodeConfig = ({data}) => {
  const renderEntireGroup = (changes, title, type, columns) => {
     if (!changes?.length) return null;
     return(
       <div>
       <h4
         className="ant-typography ant-typography-md font-medium mb-3"
         style={{ textAlign: "left", fontSize: "16px" }}
       >
         {title}
       </h4>
       <Card
       style={{
         background: '#fff',
         borderRadius: '8px',
         boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
       }}
       >
         {renderRegularGroup(changes, title, type, columns)}
       </Card>
       </div>
     )
   }
 
   const renderDetails = () => {
     const driverRatesZipcodes = data?.difference[0]?.city_zipcodes_config ?? [];
     const incomingAction = data?.difference[0]?.city_zipcodes_config?.[0]?.action;
     const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference: driverRatesZipcodes });
     const incomingEntry = driverRatesZipcodes[0]?.new_value ? "New Entry" : "Old Entry";
     const incomingTable = getDriverRatesZonesColumns(driverRatesZipcodes, "driverRatesZones");
     return (
       <div className="mt-6">
           <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
               <span style={{ fontSize: '20px', color: '#395484' }}>City ZipCode Config Details</span>
               <div className="mt-6">
                   {renderEntireGroup(groupedDifferences.REMOVED, 'Deleted Entry', 'REMOVED', incomingTable)}
                   {renderEntireGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED', incomingTable)}
                   {renderModifiedGroup(groupedDifferences.MODIFIED, [], "driverRatesZones")}
               </div>
           </h4>
       </div>
   );
   }
 
   return (
     <Row gutter={[16, 32]}>
       <Col span={24}>{renderDetails()}</Col>
     </Row>
   )
}
